import flat from 'flat';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { useAsync } from 'react-use';
import services from 'services';

const language = navigator.language.split('-')[0];

export default function withIntlProvider<P extends object>(
  WrappedComponent: React.FunctionComponent<P>,
  programCode: number,
) {
  return function ComponentWithTranslationProvider(props: P) {
    const mountedRef = React.useRef(true);

    useAsync(async () => {
      try {
        const { data }: { data: object } = await services.getLocalData(programCode, language);
        if (mountedRef.current) window.appIntl = flat(data);
      } catch (e) {
        console.error(e);
      }
    }, []);

    React.useEffect(() => {
      return () => {
        mountedRef.current = false;
      };
    }, []);

    return (
      <IntlProvider locale={language} messages={window.appIntl}>
        <WrappedComponent {...props} />
      </IntlProvider>
    );
  };
}
